export default "__VITE_PUBLIC_ASSET__656f4095__"